import React from 'react';
import ReactApexChart from 'react-apexcharts';

const RideDonutChart = ({ second_chart_data }) => {
    // Extract data from the second_chart_data prop
    const wts_bookings = second_chart_data?.wts_bookings;
    const pt_bookings = second_chart_data?.pt_bookings;
    const kyc_bookings = second_chart_data?.kyc_bookings;

    const totalUsers = (wts_bookings?.count || 0) + (pt_bookings?.count || 0) + (kyc_bookings?.count || 0);

    // Prepare chart options and series
    const basicDonutChartOptions = {
        chart: {
            type: 'donut',
        },
        labels: ['WhatsApp Rides', 'Partner Rides', 'KYC Rides'],
        colors: ['#34D399', '#F87171', '#60A5FA'], // Added a new color for KYC Rides
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
    };

    const basicDonutChartSeries = [
        wts_bookings?.count || 0,
        pt_bookings?.count || 0,
        kyc_bookings?.count || 0,
    ];

    return (
        <div className="card p-0">
            <div className="card-body text-center d-flex flex-wrap align-items-start justify-content-center">
                <div className="position-relative">
                    <ReactApexChart
                        id="basicDonutChart"
                        className="w-auto d-inline-block"
                        options={basicDonutChartOptions}
                        series={basicDonutChartSeries}
                        type="donut"
                        height={190}
                    />
                    <div className="position-absolute start-50 top-50 translate-middle">
                        <span className="text-md text-secondary-light fw-medium">
                            Total Value
                        </span>
                        <h4 className="mb-0">{totalUsers}</h4>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th className="text-start">Label</th>
                                    <th className="text-center">Value</th>
                                    <th className="text-end">%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="d-flex align-items-center gap-2">
                                        <span className="w-12-px h-12-px bg-success-600 rounded-circle" />
                                        WhatsApp Rides
                                    </td>
                                    <td className="text-center">{wts_bookings?.count ?? 0}</td>
                                    <td className="text-end">{wts_bookings?.percentage ?? 0}%</td>
                                </tr>
                                <tr>
                                    <td className="d-flex align-items-center gap-2">
                                        <span className="w-12-px h-12-px bg-danger rounded-circle" />
                                        Partner Rides
                                    </td>
                                    <td className="text-center">{pt_bookings?.count ?? 0}</td>
                                    <td className="text-end">{pt_bookings?.percentage ?? 0}%</td>
                                </tr>
                                <tr>
                                    <td className="d-flex align-items-center gap-2">
                                        <span className="w-12-px h-12-px bg-primary rounded-circle" />
                                        KYC Rides
                                    </td>
                                    <td className="text-center">{kyc_bookings?.count ?? 0}</td>
                                    <td className="text-end">{kyc_bookings?.percentage ?? 0}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RideDonutChart;
